import { createSelector, createSlice } from "@reduxjs/toolkit";
import { ensureArray } from "../common/utils/arrayUtilities";
import { logout } from "../common/reducers/initContext";
import { dataHookFactory } from "../common/reducers/utilities";

const comparator = (a,b) => a.sequence - b.sequence;

export const jobStatusSlice = createSlice({
    name: 'jobStatus',
    initialState: {
        data: []
    },
    reducers: {
        set: (state, action) => {
            state.data = action.payload
            state.data.sort(comparator);
        },
        addOrUpdate: (state, action) => {
            for (const status of ensureArray(action.payload)) {
                const idx = state.data.findIndex(s => s.name === status.name);
                if (idx > -1) {
                    state.data.splice(idx, 1, status);
                } else {
                    state.data.push(status);
                }
            }
            state.data.sort(comparator);
        },
        remove: (state, action) => {
            for (const status of ensureArray(action.payload)) {
                const idx = state.data.findIndex(s => s.name === status.name);
                if (idx > -1) {
                    state.data.splice(idx, 1)
                }
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => jobStatusSlice.getInitialState());
    }
});

// #region network operations
const fetchJobStatuses = network => network.get('/api/v1/jobstatuses', jobStatusSlice.actions.set);
export const createJobStatus = (network, status) => network.post('/api/v1/jobstatus', status, jobStatusSlice.actions.addOrUpdate);
export const updateJobStatus = (network, status) => network.put('/api/v1/jobstatus', status, jobStatusSlice.actions.addOrUpdate);
export const removeJobStatus = (network, status) => network.delete('/api/v1/jobstatus/' + encodeURIComponent(status.name), jobStatusSlice.actions.remove);
// #endregion

// #region selectors
const selectJobStatuses = state => state.jobStatus.data
const selectJobStatusByName = createSelector([selectJobStatuses, (state, name) => name], (statuses, name) => statuses.find(s => s.name === name));
const selectJobStatus = name => state => selectJobStatusByName(state, name);
// #endregion

// #region listeners
const listen = {
    jobStatusCreated: (status, { dispatch }) => dispatch(jobStatusSlice.actions.addOrUpdate(status)),
    jobStatusUpdated: (status, { dispatch }) => dispatch(jobStatusSlice.actions.addOrUpdate(status)),
    jobStatusRemoved: (status, { dispatch }) => dispatch(jobStatusSlice.actions.remove(status))
}
// #endregion

// #region permission checks
export const canInsertJobStatus = (credentials) => credentials.access.hasFull('administrator');
export const canUpdateJobStatus = canInsertJobStatus;
export const canRemoveJobStatus = canInsertJobStatus;
// #endregion

export const [useJobStatuses] = dataHookFactory(selectJobStatuses, { run: fetchJobStatuses, listen, immortal: true });
export const [useJobStatus] = dataHookFactory(selectJobStatus, name => ({ run: fetchJobStatuses, listen, immortal: true }));

const reducerDetails = { name: jobStatusSlice.name, reducer: jobStatusSlice.reducer };
export default reducerDetails;